import { createContext } from 'react'
import { UserResponse } from '../types/user'

export type AuthStatus = 'checking' | 'authenticated' | 'unauthenticated'

export interface AuthContextType {
    user: UserResponse | null
    authStatus: AuthStatus
    loading: boolean
    login: (account: string, password: string) => Promise<boolean>
    logout: () => void
    refreshUser: () => Promise<UserResponse | null>
}

// 将 Context 创建移至此处
export const AuthContext = createContext<AuthContextType | undefined>(undefined)
